import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import ReactLoading from 'react-loading';
import { injectStripe } from 'react-stripe-elements';
import classnames from 'classnames';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import CheckoutRecipientInformation from './CheckoutRecipientInformation';
import CheckoutBillingAddress from './CheckoutBillingAddress';
import CheckoutDeliveryAddress from './CheckoutDeliveryAddress';
import CheckoutDeliveryOptions from './CheckoutDeliveryOptions';
import CheckoutDiscountCode from './CheckoutDiscountCode';
import CheckoutPurchaseOrderNumber from './CheckoutPurchaseOrderNumber';
import CheckoutPaymentMethods from './CheckoutPaymentMethods';
import CheckoutPaymentSummary from './CheckoutPaymentSummary';
import { axiosApplyCoupon } from '../../actions/couponActions';
import {
    axiosProcessPayment,
    axiosRequestCheckoutDetail,
    axiosRequestDeliveryOptions,
    axiosUpdateCheckout,
    axiosUpdatePaymentMethod,
    axiosUpdateShipping,
    axiosUpdateShippingAddress,
    axiosUpdateDispatchLocation,
} from '../../actions/checkoutActions';
import { axiosRequestCreditCards } from '../../actions/creditCardActions';
import {
    axiosUpdateSelectedSupplierInformation,
    axiosUpdateAccountHolderInformation,
} from '../../actions/userActions';
import { axiosCreateAddress } from '../../actions/user/address';
import {
    convertCartDetailsToAReadableFormat,
    convertDeliveryOptionsToAReadableFormat,
    convertUserDetailedInformationToAReadableFormat,
} from '../../selectors/converterSelector';
// import PropTypes from 'prop-types';
import {
    validateForm,
    validateFormWithMessage,
} from '../../selectors/defaultSelectors';
import {
    handleAxiosErrors,
    handleDefaultAJAXResponse,
    handleDefaultAJAXSAResponse,
} from '../../_utils';
import {
    buildProcessPaymentPayload,
    buildUpdateOrderPayload,
} from '../../selectors/checkoutSelector';
import { createAlert } from '../../dom/window';
import { getAvailablePaymentMethods } from '../../selectors/paymentSelector';
import paymentConfig from '../../store/_payment';
import useDidMountEffect from '../../hooks/useDidMountEffect';
import Axios from 'axios';
import CheckoutDispatchLocation from './CheckoutDispatchLocation';
import AccountHolderInformationForm from '../AccountDetailForm/BasicInfo/AccountHolderInformationForm';
import AccountGuestUserInformationForm from '../AccountDetailForm/BasicInfo/AccountGuestUserInformationForm';
import CheckoutNewAddressForm from './CheckoutNewAddressForm';
import { createModal, hideModal, showModal } from '../../dom/components/confirm-removal-modal';
import { axiosRequestCustomer, axiosRequestCustomers, axiosRequestValidateCustomerEmail } from '../../actions/customerActions';

const getInitialPaymentMethod = (data) => {
    const {
        canUseCreditCard,
        canUseBankTransfer,
        canUseChargeAccount,
        canUsePayFast,
    } = data;
    if (
        window.currentOrderPaymentMethod ==
        'order-card-authorization-payfast' &&
        window.isEditOrder
    ) {
        return paymentConfig.gatewayNames.payfast;
    } else if (canUseCreditCard) {
        return paymentConfig.gatewayNames.stripe;
    } else if (canUseBankTransfer) {
        return paymentConfig.gatewayNames.bankTransfer;
    } else if (canUseChargeAccount) {
        return paymentConfig.gatewayNames.accountBalance;
    } else if (canUsePayFast) {
        return paymentConfig.gatewayNames.payfast;
    }
    return '';
};

const getAvailablePaymentMethodsData = (props) => {
    const { globalConfig, canUseSavedCard, orderOnBehalf } = props;

    let paymentMethodsProps = {
        ...getAvailablePaymentMethods(globalConfig.CheckoutPaymentMethods),
        canUseSavedCard: canUseSavedCard,
    };

    if (orderOnBehalf) {
        paymentMethodsProps.canUseSavedCard = false;
    }

    // LP-1662 - Remove Bank Transfer Option
    // paymentMethodsProps.canUseBankTransfer = false;

    return paymentMethodsProps;
};

function CheckoutForm(props) {
    const {
        user,
        allAddresses,
        submitAccountHolderInformation,
        billingAddresses,
        requestUserInfo,
        requestDisPatchLocationFilter,
        isUserLoading,
        isDispatchLoading,
        showDeliveryAddressDropdown,
        canUseSavedCard,
        orderOnBehalf,
        globalConfig = {},
        dispatchLocations = [],
        defaultDisaptchLocationID = 0,
    } = props;
    console.log('isDispatchLoading,', isDispatchLoading);
    const availablePaymentMethodData = getAvailablePaymentMethodsData(props);
    const showDispatchLocations = window.isEditOrder;
    const [isAccountGuestFormValid, setIsAccountGuestFormValid] = useState(
        false
    );
    const [guestFormData, setGuestFormData] = useState({});
    const [addressFormData, setAddressFormData] = useState({});
    const [isNewAddressFormValid, setIsNewAddressFormValid] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [isValidated, setIsValidated] = useState(false);
    const [isCreditCardValidated, setIsCreditCardValidated] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitPressed, setIsSubmitPressed] = useState(false);
    const [fieldStatus, setFieldStatus] = useState({});
    // const [isGuestUserFormValidated, setIsGuestUserFormValidated] = useState(
    //     false
    // );

    // Checkout data from backend
    const [checkoutData, setCheckoutData] = useState({
        CreditCardID: 0,
        // BillingAddressID: '',
        ShippingID: '',
        Notes: '',
        // For creating new credit card
        Token: '',
        Number: '',
        ExpiryMonth: '',
        ExpiryYear: '',
        IsTotalGreaterThanSourceOrder: false,
        IsPaymentCaptureFailed: false,
        HasSourceOrder: false,
    });

    // User input
    let fieldRefs = {};
    const [formData, setFormData] = useState({});

    const [isLoading, setIsLoading] = useState({
        coupon: false,
        creditCards: false,
        addresses: false,
        deliveryAddressForm: false,
        deliveryOptions: false,
        summary: false,
        paymentMethod: false,
        dispatchLocation: false,
        removingCoupon: false,
    });
    const [deliveryOptions, setDeliveryOptions] = useState([]);
    const [availableCreditCards, setAvailableCreditCards] = useState([]);
    const [hasUrgentDelivery, setHasUrgentDelivery] = useState(
        window.hasUrgentDelivery || false
    );

    const disableAssignedSupplierNumber =
        typeof user?.basicInfo?.EXOAccountID != 'undefined' &&
        user?.basicInfo?.EXOAccountID != null &&
        user?.basicInfo?.EXOAccountID != '';

    const finalFormData = {
        DeliveryAddressID: user.defaultDeliveryAddressID || '',
        BillingAddressID: user.defaultBillingAddressID || '',
        DispatchLocationID: defaultDisaptchLocationID || 0,
        AssignedSupplierNumber: user.selectedAccountReference || '',
        EXOAccountID: user?.basicInfo?.EXOAccountID || '',
        ...checkoutData,
        ...formData,
        PaymentMethod: initialized
            ? formData.PaymentMethod ||
            checkoutData.PaymentMethod ||
            getInitialPaymentMethod(availablePaymentMethodData)
            : null,
    };

    console.log('User ===> ', user);
    console.log('FinalFormData ===> ', finalFormData);
    // Helper function to disable process payment
    const isSubmitButtonDisabled =
        !isValidated ||
        isUserLoading ||
        Object.values(isLoading).some((item) => item === true);

    const runStripeEndpoint =
        !finalFormData.HasSourceOrder ||
        (finalFormData.HasSourceOrder &&
            (finalFormData.IsTotalGreaterThanSourceOrder || finalFormData.IsPaymentCaptureFailed)) ||
        checkoutData.IsBackOrder;

    const isGuestUserValidate =
        isAccountGuestFormValid && isNewAddressFormValid
    // useEffect(() => {
    //     setIsGuestUserFormValidated(
    //         isAccountGuestFormValid && isNewAddressFormValid
    //     );
    // }, [isAccountGuestFormValid, isNewAddressFormValid]);
    // Effects
    // --------------------
    // - Validate form
    useEffect(() => {

        let status = !validateForm(fieldRefs);
        let fieldStatus = validateFormWithMessage(fieldRefs);

        // other check
        console.log('Debug paymentMethod', finalFormData.PaymentMethod);
        if (!finalFormData.PaymentMethod) {
            status = false;
        }

        if (
            finalFormData.PaymentMethod == 'stripe' &&
            finalFormData.CreditCardID == 'add-new-card' &&
            !isCreditCardValidated
        ) {
            status = false;
        }

        if (finalFormData.ShippingID == 0) {
            status = false;

            fieldStatus.ShippingID = {
                status: false,
                message: getTranslation('FIELD.IS_REQUIRED'),
            };
        }

        console.log('Checkout isValidated', status);
        setIsValidated(status);

        if (isSubmitPressed) {
            console.log('fieldStatus', fieldStatus);
            setFieldStatus(fieldStatus);
        }
    }, [JSON.stringify(finalFormData), isCreditCardValidated, isSubmitPressed]);

    // - Summary (every time selected delivery option updates)
    useDidMountEffect(() => {
        if (
            initialized &&
            formData.ShippingID != 0
            // Object.values(deliveryOptions).length !== 0
        ) {
            const selectedDeliveryOption = deliveryOptions[formData.ShippingID];
            console.log('selectedDeliveryOption', selectedDeliveryOption);

            if (selectedDeliveryOption) {
                let payload = null;

                if (selectedDeliveryOption.ID === null) {
                    payload = {
                        ShippingID: 0,
                        PostmenSelectedShipperInternalID:
                            selectedDeliveryOption.ShipperInternalID,
                        PostmenSelectedShipperExternalID:
                            selectedDeliveryOption.ShipperExternalID,
                        PostmenSelectedShipperServiceType:
                            selectedDeliveryOption.ShipperServiceType,
                    };
                } else {
                    payload = {
                        ShippingID: selectedDeliveryOption.ID,
                    };
                }

                updateSelectedDeliveryOption(payload);
            }
        }
    }, [initialized, formData.ShippingID]);

    // - Summary (every time dispatch location changes from drop down)
    useDidMountEffect(() => {
        if (
            initialized &&
            formData.DispatchLocationID != 0 &&
            window.isEditOrder
        ) {
            updateDispatchLocation();
        }
    }, [initialized, formData.DispatchLocationID]);

    // - Summary (every time delivery options updated)
    useDidMountEffect(() => {
        if (deliveryOptions.length > 0) {
            let found = false;
            deliveryOptions.forEach((option) => {
                if (option.FakeID == finalFormData.ShippingID) {
                    found = true;
                }
            });

            if (!found) {
                updateField('ShippingID', deliveryOptions[0].FakeID);
            }
        }
    }, [initialized, JSON.stringify(deliveryOptions)]);

    // - Summary (every time selected delivery address updates) (only for order on behalf of)
    useDidMountEffect(() => {
        if (
            initialized &&
            orderOnBehalf &&
            formData.DeliveryAddressID &&
            formData.DeliveryAddressID != 0 &&
            formData.DeliveryAddressID != 'add-new-address'
            // Object.values(deliveryOptions).length !== 0
        ) {
            updateSelectedDeliveryAddress(formData.DeliveryAddressID);
        }
    }, [initialized, formData.DeliveryAddressID]);

    useDidMountEffect(() => {
        if (
            initialized &&
            !orderOnBehalf &&
            finalFormData.DeliveryAddressID &&
            finalFormData.DeliveryAddressID != 0 &&
            finalFormData.DeliveryAddressID != 'add-new-address'
        ) {
            updateSelectedDeliveryAddress(finalFormData.DeliveryAddressID);
        }
    }, [initialized, finalFormData.DeliveryAddressID]);

    // - Every time Payment Method gets updated
    useDidMountEffect(() => {
        if (initialized) {
            console.log(
                'finalFormData.PaymentMethod========',
                finalFormData.PaymentMethod
            );
            if (
                window.localeCountry == 'South Africa' &&
                window.currentOrderPaymentMethod ==
                'order-card-authorization-payfast' &&
                window.isEditOrder
            ) {
                // Promise.all();
                return;
            } else {
                Promise.all([updatePaymentMethod()]);
            }
        }
    }, [finalFormData.PaymentMethod]);

    // - Every time Payment Method gets updated
    useEffect(() => {
        // Do this first
        Promise.all([
            orderOnBehalf ? requestUserInfo('basic') : null,
            requestDetails(),
            requestCreditCards(),
        ])
            .then(() => {
                return Promise.all([updatePaymentMethod()]);
            })
            .then(() => {
                setInitialized(true);
            });
    }, []);

    // - Wait for getting DispatchLocationID and then update the dispatch Address to default one
    useEffect(() => {
        if (defaultDisaptchLocationID && window.isEditOrder) {
            updateDispatchLocation();
        }
    }, [user]);

    // Requests
    // --------------------
    /**
     * Request order details
     */
    const requestDetails = () => {
        return axiosRequestCheckoutDetail()
            .then((response) => {
                const cartDetail = convertCartDetailsToAReadableFormat(
                    response.data.data.readOneCart
                );

                setCheckoutData((prevState) => {
                    return {
                        ...prevState,
                        ...cartDetail,
                    };
                });

                setInitialized(true);
            })
            .catch((error) => {
                handleAxiosErrors(error);
            });
    };

    /**
     * Request credit cards from user's
     */
    const requestCreditCards = () => {
        if (canUseSavedCard === false) {
            return Promise.resolve({});
        }

        toggleLoading('creditCards', true);
        return axiosRequestCreditCards()
            .then((response) => {
                const userInfo = convertUserDetailedInformationToAReadableFormat(
                    response.data.data.readOneMember
                );
                const creditCardList = userInfo.availableCreditCards || [];
                setAvailableCreditCards(creditCardList);

                if (finalFormData.CreditCardID == 0 && creditCardList.length) {
                    if (userInfo.defaultCreditCardID) {
                        updateField(
                            'CreditCardID',
                            userInfo.defaultCreditCardID.toString()
                        );
                    } else {
                        updateField('CreditCardID', creditCardList[0].ID);
                    }
                }

                toggleLoading('creditCards', false);
            })
            .catch((error) => {
                handleAxiosErrors(error);
                toggleLoading('creditCards', false);
            });
    };

    /**
     *
     * Update Dispatch Location
     */
    const updateDispatchLocation = () => {
        if (!finalFormData.DispatchLocationID || !window.isEditOrder) {
            return false;
        }

        toggleLoading('dispatchLocation', true);
        let payload = {
            DispatchLocationID: Number(finalFormData.DispatchLocationID),
        };
        return axiosUpdateDispatchLocation(payload)
            .then((response) => {
                return Promise.all([
                    !window.isGuestUser ? requestDeliveryOptions() : {},
                    props.requestCart(),
                ]);
            })
            .catch((error) => {
                handleAxiosErrors(error);
            })
            .finally(() => {
                toggleLoading('dispatchLocation', false);
            });
    };

    /**
     * Update payment method
     */
    const updatePaymentMethod = () => {
        if (!finalFormData.PaymentMethod) {
            return false;
        }

        toggleLoading('paymentMethod', true);
        axiosUpdatePaymentMethod;
        return axiosUpdatePaymentMethod(finalFormData.PaymentMethod)
            .then((response) => {
                return Promise.all([
                    // requestDeliveryOptions(),
                    !window.isGuestUser ? requestDeliveryOptions() : {},
                    props.requestCart(),
                ]);
            })
            .catch((error) => {
                handleAxiosErrors(error);
            })
            .finally(() => {
                toggleLoading('paymentMethod', false);
            });
    };

    const processNewCreditCardToken = (passedData) => {
        console.log('DEBUG runStripeEndpoint', runStripeEndpoint);

        return new Promise((resolve, reject) => {
            let creditCardID =
                typeof passedData.CreditCardID != 'undefined' &&
                    passedData.CreditCardID != 'add-new-card'
                    ? passedData.CreditCardID
                    : 0;

            if (
                runStripeEndpoint &&
                passedData.PaymentMethod == 'stripe' &&
                creditCardID == 0
            ) {
                if (props.stripe) {
                    props.stripe.createToken().then((stripeResponse) => {
                        const { token } = stripeResponse;
                        if (token) {
                            // Parse token from Stripe
                            const stripeCard = token.card;

                            passedData = {
                                ...passedData,
                                Token: token.id,
                                Number: 'x'.repeat(12) + stripeCard.last4,
                                ExpiryMonth: stripeCard.exp_month,
                                ExpiryYear: stripeCard.exp_year,
                            };

                            resolve({
                                identifier: 'stripe',
                                status: 1,
                                data: passedData,
                            });
                        } else {
                            reject({
                                identifier: 'stripe',
                                status: 0,
                                message: getTranslation(
                                    'STRIPE_CONNECT_FORM.ERROR_TOKEN'
                                ),
                                data: passedData,
                            });
                        }
                    });
                } else {
                    reject({
                        identifier: 'stripe',
                        status: 0,
                        message: getTranslation(
                            'STRIPE_CONNECT_FORM.ERROR_JS_LOADED'
                        ),
                        data: passedData,
                    });
                }
            } else {
                resolve({
                    identifier: 'stripe',
                    status: 1,
                    data: passedData,
                });
            }
        });
    };

    const processUpdateMemberSupplierInfo = (passedData) => {
        return new Promise((resolve, reject) => {
            if (passedData.PaymentMethod == 'accountbalance') {
                axiosUpdateSelectedSupplierInformation({
                    AccountReference: passedData.AssignedSupplierNumber,
                })
                    .then((response) => {
                        resolve({
                            identifier: 'accountbalance',
                            status: 1,
                            data: passedData,
                        });
                    })
                    .catch((response) => {
                        handleAxiosErrors(response);

                        reject({
                            identifier: 'accountbalance',
                            status: 0,
                            data: passedData,
                        });
                    });
            } else {
                resolve({
                    identifier: 'accountbalance',
                    status: 1,
                    data: passedData,
                });
            }
        });
    };

    const requestDeliveryOptions = () => {
        toggleLoading('deliveryOptions', true);

        return axiosRequestDeliveryOptions()
            .then((response) => {
                const options =
                    convertDeliveryOptionsToAReadableFormat(
                        response.data.data.readCombinedShippingMethods
                    ) || [];

                setDeliveryOptions(options);

                toggleLoading('deliveryOptions', false);
            })
            .catch((error) => {
                handleAxiosErrors(error);
                toggleLoading('deliveryOptions', false);
            });
    };

    const updateSelectedDeliveryOption = (payload) => {
        toggleLoading('delivery', true);
        return axiosUpdateShipping(payload)
            .then((response) => {
                return Promise.all([props.requestCart(), requestDetails()]);
            })
            .catch((error) => {
                handleAxiosErrors(error);
            })
            .finally(() => {
                toggleLoading('delivery', false);
            });
    };

    /**
     * Create a new address
     *
     * @param formData
     * @param callback
     */
    const handleNewAddressSubmission = (
        formData,
        callback,
        updatedFieldKey = ''
    ) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        toggleLoading('addresses', true);

        return axiosCreateAddress(
            formData,
            orderOnBehalf === true ? user.basicInfo.ID : null
        )
            .then((response) => {
                toggleLoading('addresses', false);

                Promise.all([requestUserInfo('basic')]).then(() => {
                    // Update billing address
                    if (
                        response.data.data &&
                        response.data.data.createDeliveryAddress &&
                        typeof response.data.data.createDeliveryAddress.ID !=
                        'undefined'
                    ) {
                        handleBillingAddressLabel(
                            'BillingAddressLabel',
                            response.data.data.createDeliveryAddress.FullAddress
                        );
                        handleDeliveryAddressLabel(
                            'DeliveryAddressLabel',
                            response.data.data.createDeliveryAddress.FullAddress
                        );
                        if (updatedFieldKey) {
                            updateField(
                                updatedFieldKey,
                                response.data.data.createDeliveryAddress.ID
                            );
                        }
                    }
                });

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                toggleLoading('addresses', false);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };

    const updateSelectedDeliveryAddress = (shippingAddressID) => {
        toggleLoading('deliveryAddress', true);
        return axiosUpdateShippingAddress(shippingAddressID)
            .then((response) => {
                return Promise.all([
                    !window.isGuestUser ? requestDeliveryOptions() : {},
                    props.requestCart(),
                ]);
            })
            .catch((error) => {
                handleAxiosErrors(error);
            })
            .finally(() => {
                toggleLoading('deliveryAddress', false);
            });
    };

    const applyDiscountCode = (e) => {
        const lastDiscountCode = formData['ignore:LastDiscountCode'] || '';
        const currentDiscountCode = formData['DiscountCode'] || '';

        // if (lastDiscountCode != currentDiscountCode) {
        toggleLoading('coupon', true);
        return axiosApplyCoupon(currentDiscountCode)
            .then((response) => {
                updateField('ignore:LastDiscountCode', currentDiscountCode);
                console.log(response);
                toggleLoading('coupon', false);

                // re-request cart
                requestDetails();
                props.requestCart();
                requestDeliveryOptions();
            })
            .catch((error) => {
                handleAxiosErrors(error);
                toggleLoading('coupon', false);
            });
        // }
    };

    /**
     * Process payment
     */

    const processPaymentPayFast = (e) => {
        e.preventDefault();
        // process payment
        setIsSubmitPressed(true);
        if (
            window.currentOrderPaymentMethod !=
            'order-card-authorization-payfast' &&
            !window.isEditOrder
        ) {
            if (isSubmitButtonDisabled === true) {
                return;
            }
        }
        setIsSubmitting(true);

        let payload = JSON.parse(JSON.stringify(finalFormData));

        Promise.all([processUpdateMemberSupplierInfo(payload)])
            .then((preResponse) => {
                let checkoutResponseData = null;

                preResponse.forEach((item) => {
                    checkoutResponseData = item.data;
                });

                console.log('Debug checkoutResponseData', checkoutResponseData);

                if (checkoutResponseData == null) {
                    setIsSubmitting(false);
                    createAlert(
                        { message: getTranslation('FIELD.SOMETHING_WRONG') },
                        'error'
                    );
                    console.error('Something wrong with the process');
                } else {
                    let orderPayload = buildUpdateOrderPayload(
                        checkoutResponseData,
                        {
                            deliveryOptions: deliveryOptions,
                        }
                    );
                    const paymentPayload = {
                        paymentMethod: 'order-payfast',
                    };

                    console.log(orderPayload, paymentPayload);

                    // Update order
                    axiosUpdateCheckout(orderPayload)
                        .then((orderResponse) => {
                            console.log(orderResponse);

                            // process payment
                            axiosProcessPayment(paymentPayload)
                                .then((paymentResponse) => {
                                    if (
                                        window.currentOrderPaymentMethod ==
                                        'order-card-authorization-payfast' &&
                                        window.isEditOrder
                                    ) {
                                        handleDefaultAJAXResponse(
                                            paymentResponse.data,
                                            {
                                                always: () => {
                                                    setIsSubmitting(false);
                                                },
                                            }
                                        );
                                    } else {
                                        handleDefaultAJAXSAResponse(
                                            paymentResponse.data,
                                            {
                                                always: () => {
                                                    setIsSubmitting(false);
                                                },
                                            }
                                        );
                                    }
                                })
                                .catch((paymentResponse) => {
                                    console.log(paymentResponse);
                                    handleAxiosErrors(paymentResponse);
                                    setIsSubmitting(false);
                                });
                        })
                        .catch((orderResponse) => {
                            console.log(orderResponse);
                            handleAxiosErrors(orderResponse);
                            setIsSubmitting(false);
                        });
                }
            })
            .catch((ccResponse) => {
                console.log(ccResponse);
                handleAxiosErrors(ccResponse);
                setIsSubmitting(false);
            });

        // axiosProcessPayment(paymentPayload)
        //     .then((paymentResponse) => {
        //         handleDefaultAJAXResponse(paymentResponse.data, {

        //             always: () => {
        //                 setIsSubmitting(false);
        //                 console.log(paymentResponse.data)
        //             },

        //         });
        //     })
        //     .catch((paymentResponse) => {
        //         console.log(paymentResponse);

        //         createAlert(paymentResponse, 'success');
        //         setIsSubmitting(false);
        //     });
    };

    /**
     * Process payment
     */
    const processPayment = (e) => {
        e.preventDefault();

        // Helper to mark
        setIsSubmitPressed(true);

        if (isSubmitButtonDisabled === true) {
            return;
        }

        setIsSubmitting(true);

        let payload = JSON.parse(JSON.stringify(finalFormData));
        let MemberUpdatePayload = { EXOAccountID: payload.EXOAccountID };
        Promise.all([
            processNewCreditCardToken(payload),
            //processUpdateMemberSupplierInfo(payload),
            axiosUpdateAccountHolderInformation(MemberUpdatePayload),
        ])
            .then((preResponse) => {
                let checkoutResponseData = null;

                preResponse.forEach((item) => {
                    if (item.identifier == 'stripe') {
                        checkoutResponseData = item.data;
                    }
                });

                console.log('Debug checkoutResponseData', checkoutResponseData);
                if (checkoutResponseData == null) {
                    setIsSubmitting(false);
                    createAlert(
                        { message: getTranslation('FIELD.SOMETHING_WRONG') },
                        'error'
                    );
                    console.error('Something wrong with the process');
                } else {
                    let orderPayload = buildUpdateOrderPayload(
                        checkoutResponseData,
                        {
                            deliveryOptions: deliveryOptions,
                        }
                    );
                    let paymentPayload = buildProcessPaymentPayload(
                        checkoutResponseData
                    );

                    console.log(orderPayload, paymentPayload);

                    // Update order
                    axiosUpdateCheckout(orderPayload)
                        .then((orderResponse) => {
                            console.log(orderResponse);

                            // process payment
                            axiosProcessPayment(paymentPayload)
                                .then((paymentResponse) => {
                                    handleDefaultAJAXResponse(
                                        paymentResponse.data,
                                        {
                                            always: () => {
                                                setIsSubmitting(false);
                                            },
                                        }
                                    );
                                })
                                .catch((paymentResponse) => {
                                    console.log(paymentResponse);
                                    handleAxiosErrors(paymentResponse);
                                    setIsSubmitting(false);
                                });
                        })
                        .catch((orderResponse) => {
                            console.log(orderResponse);
                            handleAxiosErrors(orderResponse);
                            setIsSubmitting(false);
                        });
                }
            })
            .catch((ccResponse) => {
                console.log(ccResponse);
                handleAxiosErrors(ccResponse);
                setIsSubmitting(false);
            });
    };

    // Functions
    // --------------------
    const toggleLoading = (key, value) => {
        setIsLoading((prevState) => {
            // console.log('Loading State', {
            //     ...prevState,
            //     [key]: value,
            // });

            return {
                ...prevState,
                [key]: value,
            };
        });
    };

    const updateField = (key, value) => {
        console.log('emailholder12', value)
        setFormData((prevState) => {
            console.log('Field State:', {
                ...prevState,
                [key]: value,
            });

            return {
                ...prevState,
                [key]: value,
            };
        });
    };

    const handleFormUpdate = (e) => {
        updateField(e.target.name, e.target.value);
    };

    const handleGuestUserFormUpdate = (e) => {
        console.log('eeeeee', e);
    };

    const handleFormUpdateDeliveryAddress = (e, v) => {
        if (e.label != null) {
            console.log('etarget', e.value, v.name);
            updateField(v.name, e.value);
        } else {
            updateField(e, v);
        }
    };

    const handleFormUpdateDispatchLocation = (e, v) => {
        if (e.label != null) {
            console.log('etarget', e.value, v.name);
            updateField(v.name, e.value);
        } else {
            updateField(e, v);
        }
    };

    const handleBillingAddressLabel = (e, v) => {
        updateField(e, v);
    };
    const handleDeliveryAddressLabel = (e, v) => {
        updateField(e, v);
    };
    const handleFormUpdateBillingAddress = (e, v) => {
        if (e.label != null) {
            updateField(v.name, e.value);
        } else {
            updateField(e, v);
        }
    };
    const handleFormUpdateNumber = (e) => {
        updateField(e.target.name, Number(e.target.value));
    };

    const checkValidEmail = async (e) => {
        return axiosRequestValidateCustomerEmail(e.target.value)
            .then((response) => {

                console.log('resposneholder', response.data.data.validateEmail);
                if (!response.data.data.validateEmail) {
                    $('#inputEmail').val(
                        guestFormData.Email
                    );
                    $('#checkout-login-form').modal('show');
                }
            })
            .catch((error) => {
                handleAxiosErrors(error);
            });
    }

    const handleSubmit = async (e) => {

        e.preventDefault();
        setIsSubmitting(true);


        try {
            const accountHolderFormData = { ...guestFormData };
            const addressData = { ...addressFormData };

            // Submit Account Holder Information
            await submitAccountHolderInformation(accountHolderFormData, {
                success: async (response) => {
                    console.log(
                        'Account Holder Info Submitted Successfully:',
                        response
                    );

                    // Submit New Address Form with proper formData
                    await handleNewAddressSubmission(addressData, {
                        success: (response) => {
                            console.log(
                                'New Address Submitted Successfully:',
                                response
                            );

                            const addressId = response.data.data.createDeliveryAddress.ID

                            updateAccountInformation(addressId)

                        },
                        error: (err) => {
                            console.error('Error Submitting New Address:', err);
                        },
                        always: () => {
                            setIsSubmitting(false);
                        },
                    });
                },
                error: (err) => {


                    console.error('Error Submitting Account Holder Info:', err);
                },
                always: () => {
                    setIsSubmitting(false);
                },
            });
        } catch (error) {
            console.error('Error submitting forms:', error);
            setIsSubmitting(false);
        }
    };

    const updateAccountInformation = (e) => {
        toggleLoading('submit', true);
        let payload = {
            DeliveryAddressID: e,
            ParentID: user.selectedParentID,
        };

        if (payload.ParentID == 0) {
            delete payload.ParentID;
        }

        axiosUpdateAccountHolderInformation(payload)
            .then((response) => {
                window.location.href = '/checkout/payment';

            })
            .catch((response) => {
                handleAxiosErrors(response);
                toggleLoading('submit', false);
                window.location.href = '/checkout/payment';
            });
    };

    const handleLogin = async () => {
        // window.location.href = '/en_HK/sign-in/';
        $('#checkout-login-modal-form').modal('show');
    };
    return (
        <React.Fragment>
            <div className='card card--nopadding react-component'>
                <div className='row row-sm-eqheight row--nopadding'>
                    <div className='col-sm-6 col-md-7 col-lg-8'>
                        <div className='content-box content-box--border content-box--big checkout-form__main'>
                            {/* Recipient Information */}
                            {window.isGuestUser ? (
                                <>
                                    <div className='card__header'>
                                        <span className='card__header-wrapper'>
                                            <span className='card__header-icon'>
                                                <span className='icon icon-info' />
                                            </span>
                                        </span>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <h3 className='heading heading--lv4 pt-15'>
                                                    <LocalizedMessage
                                                        id={
                                                            'ACCOUNT_HOLDER_IMP_INFORMATION_FORM.HEADING'
                                                        }
                                                    />
                                                </h3>
                                            </div>
                                            <div className='col-md-6 ts-right text-right tx-right'>
                                                <button
                                                    type='button'
                                                    className='button buttom--small'
                                                    id='sign-in-button'
                                                    onClick={handleLogin}
                                                    data-toggle-menu-item=''
                                                    title='Login'
                                                >
                                                    <span>
                                                        Login
                                                    </span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='vspace vspace--small'>
                                            <div className='text-box'>
                                                <p className='pb-0 '>
                                                    For returning customers that have ordered before, please click <strong>LOGIN.</strong>
                                                </p>
                                                <p>If this is your first time ordering, please fill in the fields below. Be sure to remember your email address and password, as you will need to <strong>LOGIN</strong> next time to complete your checkout.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <form onSubmit={handleSubmit}>
                                        <AccountGuestUserInformationForm
                                            {...props}
                                            data={user.basicInfo}
                                            businessAddress={
                                                user.businessAddress || {}
                                            }
                                            setGuestFormData={setGuestFormData}
                                            setFormValid={
                                                setIsAccountGuestFormValid
                                            }
                                            checkValidEmail={checkValidEmail}
                                            handleFormSubmission={
                                                submitAccountHolderInformation
                                            }
                                            setAddressFormData={
                                                setAddressFormData
                                            }
                                            // handleFormSubmission={
                                            //     handleNewAddressSubmission
                                            // }
                                            updateField={updateField}
                                            setIsNewAddressFormValid={
                                                setIsNewAddressFormValid
                                            }
                                        />


                                        <div className='vspace tx-right'>
                                            <button
                                                type='submit'
                                                className={classnames(
                                                    'button ',
                                                    {
                                                        'button--disabled': !isGuestUserValidate,
                                                    }
                                                )}
                                                disabled={
                                                    !isGuestUserValidate ||
                                                    isSubmitting
                                                }
                                            >
                                                {isSubmitting ? (
                                                    <ReactLoading
                                                        type='spin'
                                                        color='white'
                                                        height={20}
                                                        width={20}
                                                    />
                                                ) : (
                                                    'Submit'
                                                )}
                                            </button>
                                        </div>
                                        <div></div>
                                    </form>
                                </>
                            ) : (
                                <CheckoutRecipientInformation
                                    {...props}
                                    disableRecipientModification={true}
                                    fieldRefs={fieldRefs}
                                    fieldStatus={fieldStatus}
                                    orderOnBehalf={orderOnBehalf}
                                    formData={finalFormData}
                                    handleFormUpdate={handleFormUpdate}
                                />
                            )}

                            {!window.isGuestUser && (
                                <>
                                    {/* Delivery Address */}
                                    <CheckoutDeliveryAddress
                                        {...props}
                                        fieldRefs={fieldRefs}
                                        fieldStatus={fieldStatus}
                                        isLoading={
                                            isUserLoading ||
                                            isLoading.deliveryAddress
                                        }
                                        requestUserInfo={requestUserInfo}
                                        formData={finalFormData}
                                        handleDeliveryAddressLabel={
                                            handleDeliveryAddressLabel
                                        }
                                        handleFormUpdateDeliveryAddress={
                                            handleFormUpdateDeliveryAddress
                                        }
                                        // handleFormUpdate={handleFormUpdate}
                                        handleNewAddressSubmission={(
                                            formData,
                                            callback
                                        ) =>
                                            handleNewAddressSubmission(
                                                formData,
                                                callback,
                                                'DeliveryAddressID'
                                            )
                                        }
                                        availableAddresses={allAddresses}
                                        showDeliveryAddressDropdown={
                                            showDeliveryAddressDropdown
                                        }
                                    />

                                    {/* Dispatch Locations */}
                                    {showDispatchLocations && (
                                        <CheckoutDispatchLocation
                                            {...props}
                                            fieldRefs={fieldRefs}
                                            fieldStatus={fieldStatus}
                                            requestDisPatchLocationFilter={
                                                requestDisPatchLocationFilter
                                            }
                                            handleFormUpdateDispatchLocation={
                                                handleFormUpdateDispatchLocation
                                            }
                                            isLoading={isDispatchLoading}
                                            formData={finalFormData}
                                            handleFormUpdate={handleFormUpdate}
                                            dispatchLocations={
                                                dispatchLocations
                                            }
                                        />
                                    )}

                                    {/* Freight / Handling & Notes */}
                                    <CheckoutDeliveryOptions
                                        {...props}
                                        fieldRefs={fieldRefs}
                                        fieldStatus={fieldStatus}
                                        isLoading={isLoading}
                                        formData={finalFormData}
                                        handleFormUpdate={handleFormUpdate}
                                        handleFormUpdateNumber={
                                            handleFormUpdateNumber
                                        }
                                        deliveryOptions={deliveryOptions}
                                        hasUrgentDelivery={hasUrgentDelivery}
                                        updateField={updateField}
                                    />

                                    {/* Billing Address */}
                                    <CheckoutBillingAddress
                                        {...props}
                                        fieldRefs={fieldRefs}
                                        requestUserInfo={requestUserInfo}
                                        fieldStatus={fieldStatus}
                                        isLoading={isUserLoading}
                                        formData={finalFormData}
                                        handleBillingAddressLabel={
                                            handleBillingAddressLabel
                                        }
                                        handleFormUpdate={handleFormUpdate}
                                        handleFormUpdateBillingAddress={
                                            handleFormUpdateBillingAddress
                                        }
                                        handleNewAddressSubmission={(
                                            formData,
                                            callback
                                        ) =>
                                            handleNewAddressSubmission(
                                                formData,
                                                callback,
                                                'BillingAddressID'
                                            )
                                        }
                                        availableAddresses={billingAddresses}
                                    />
                                </>
                            )}
                            <a
                                href='/checkout/cart'
                                className='button-link-plain button-link-plain--big button-link-plain--back hidden-xs'
                            >
                                <LocalizedMessage id={'RETURN_TO_CART'} />
                            </a>
                        </div>
                    </div>
                    <div className='col-sm-6 col-md-5 col-lg-4'>
                        <div className='content-box content-box--small checkout-form__side'>
                            <div className='card__header'>
                                <h5 className='heading--lv5 heading'>
                                    <LocalizedMessage id={'PAYMENT_METHOD'} />
                                </h5>
                            </div>
                            <div className='vspace'>
                                {/* Payment Methods */}
                                <CheckoutPaymentMethods
                                    {...props}
                                    checkoutData={checkoutData}
                                    autoSelectDefaultPaymentMethod={false}
                                    globalConfig={globalConfig}
                                    fieldRefs={fieldRefs}
                                    fieldStatus={fieldStatus}
                                    isLoading={isLoading.paymentMethod}
                                    creditCardList={availableCreditCards}
                                    orderOnBehalf={orderOnBehalf}
                                    formData={finalFormData}
                                    availablePaymentMethods={
                                        availablePaymentMethodData
                                    }
                                    handleFormUpdate={handleFormUpdate}
                                    handleFormUpdateNumber={
                                        handleFormUpdateNumber
                                    }
                                    updateField={updateField}
                                    setIsCreditCardValidated={
                                        setIsCreditCardValidated
                                    }
                                    disableAssignedSupplierNumber={
                                        disableAssignedSupplierNumber
                                    }
                                />

                                {/* Discount Code */}
                                <CheckoutDiscountCode
                                    {...props}
                                    ProductDiscountItems={
                                        checkoutData.ProductDiscountItems
                                    }
                                    AppliedDiscountTotal={
                                        checkoutData.AppliedDiscountTotal ?? 0
                                    }
                                    AppliedDiscountCouponID={
                                        checkoutData.AppliedDiscountCouponID ??
                                        0
                                    }
                                    fieldRefs={fieldRefs}
                                    fieldStatus={fieldStatus}
                                    isLoading={isLoading.coupon}
                                    formData={finalFormData}
                                    handleFormSubmission={applyDiscountCode}
                                    handleFormUpdate={handleFormUpdate}
                                    appliedDiscountCode={
                                        finalFormData.AppliedDiscountCode
                                    }
                                    requestDetails={requestDetails}
                                    requestDeliveryOptions={
                                        requestDeliveryOptions
                                    }
                                    toggleLoading={toggleLoading}
                                />

                                <CheckoutPurchaseOrderNumber
                                    {...props}
                                    fieldRefs={fieldRefs}
                                    fieldStatus={fieldStatus}
                                    isLoading={isLoading.purchaseOrderNumber}
                                    formData={finalFormData}
                                    handleFormUpdate={handleFormUpdate}
                                />

                                {/* Payment Summary */}
                                <CheckoutPaymentSummary
                                    {...props}
                                    fieldRefs={fieldRefs}
                                    fieldStatus={fieldStatus}
                                    isLoading={props.isCartLoading}
                                    detail={props.detail}
                                    currencyFormat={props.currencyFormat}
                                    currencyDisplayCode={
                                        props.currencyDisplayCode
                                    }
                                    locale={props.locale}
                                />
                            </div>
                            {!window.isGuestUser && (
                                <div className='vspace vspace--small'>
                                    <button
                                        type='submit'
                                        className={classnames(
                                            `button button--fullwidth button--big button--uppercase`,
                                            !finalFormData.PaymentMethod &&
                                            'button--disabled'
                                        )}
                                        disabled={!finalFormData.PaymentMethod}
                                        onClick={
                                            finalFormData.PaymentMethod ==
                                                'payfast'
                                                ? processPaymentPayFast
                                                : processPayment
                                        }
                                        style={{ position: 'relative' }}
                                    >
                                        <span
                                            style={{
                                                opacity:
                                                    isSubmitting === true
                                                        ? 0
                                                        : 1,
                                            }}
                                        >
                                            {finalFormData.PaymentMethod ==
                                                'accountbalance' ? (
                                                <LocalizedMessage
                                                    id={
                                                        'CHECKOUT.SUBMIT_BUTTON_CHARGE_ACCOUNT'
                                                    }
                                                />
                                            ) : (
                                                <LocalizedMessage
                                                    id={
                                                        'CHECKOUT.SUBMIT_BUTTON_DEFAULT'
                                                    }
                                                />
                                            )}
                                        </span>
                                        {isSubmitting === true && (
                                            <ReactLoading
                                                className='button__spinner'
                                                type='spin'
                                                color='white'
                                                height={20}
                                                width={20}
                                            />
                                        )}
                                    </button>
                                </div>
                            )}

                            {/*
                            <div className='text-box text-box--xsmall'>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: getTranslation(
                                            'CHECKOUT.FOOTNOTE_MESSAGE'
                                        ).replace('{currencyDisplayCode}', props.currencyDisplayCode),
                                    }}
                                />
                            </div>
                            */}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

class InjectedCheckoutForm extends React.Component {
    render() {
        return <CheckoutForm {...this.props} />;
    }
}

export default injectStripe(InjectedCheckoutForm);
